import PropTypes from 'prop-types'
import styles from './Toggle.module.css'

const Toggle = ({ onToggleClick, toggleOn = false, disabled = false, ariaLabel = 'Habilitar' }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={toggleOn}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onToggleClick}
      className={styles.toggle}
    >
      <span className={styles.toggleThumb} aria-hidden="true">
        <i className={`bi bi-${toggleOn ? 'check' : 'dash'}`} />
      </span>
    </button>
  )
}

Toggle.propTypes = {
  onToggleClick: PropTypes.func,
  toggleOn: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string
}

export default Toggle
